<template>
  <div
    class="study-ranges-aside raibudrrasd std_cont_tabs"
    :class="{ 'no-events': loadingStrategy }"
  >
    <slot name="before"></slot>
    <TabBox
      v-if="builderMode === 'mode_builder'"
      class="raibudrrasd_tabbox"
      :options="toolTabs"
      style="--tbbox-overflow-y: unset; --tbbox-overflow-x: unset"
      :hasScrollRight="false"
    >
      <template #default="{ tab }">
        <div
          class="std_cont text-noselect"
          tour="rbactions"
          style="min-height: 13.25rem"
        >
          <div
            v-if="tab === 'tools'"
            class="f-column w-100"
            style="min-width: 0"
          >
            <GwBtns
              v-show="!onStart"
              tour="lockpaint"
              :options="['painter', 'locker']"
              :value="btnMode"
              style="
                margin-bottom: 0.5rem;
                background: var(--clr-black-1-3);
                border-radius: 4px;
                --gwbtns-padding: 2px;
                --gwbtn-flex: 1;
                --gwbtn-clr-active-white: var(--clr-black-3);
              "
              @click="
                (_e, item) => {
                  $emit('click:btnmode', item)
                  $emit('click:paintmode', item === 'locker' ? 'paint_lock' : 'paint_custom')
                }
              "
            >
              <template #default="{ item }">
                <div
                  v-if="item === 'painter'"
                  class="mdi mdi-brush mr-1"
                ></div>
                <div
                  v-if="item === 'locker'"
                  class="mdi mdi-lock mr-1"
                ></div>
                {{ $t(`common.${item}`) }}
              </template>
            </GwBtns>
            <RangeBuilderActions
              v-if="lockMode === 'disabled'"
              :style="`opacity: ${onStart ? 0 : 1}`"
              style="min-height: 11rem; min-width: 0; gap: 0.25rem"
              :solution="rab_solution_paint"
              :showBetsIn="showBetsIn"
              :useHex="useHex"
              :grouping="grouping"
              v-bind="$attrs"
            >
            </RangeBuilderActions>

            <div
              v-else
              class="gw_box f-center f-column flex-1"
              style="gap: 1rem"
            >
              <div class="text-normal weight_600">
                {{ $tc('range_builder.hands_locked', lockedHands.length) }}
              </div>
              <div
                class="gw_btn gw_btn-v1"
                :class="{ 'no-events opatcity_4 clr-grey': !lockedHands.length }"
                @click="$emit('lock:reset')"
              >
                {{ $t('btn.unlock_all') }}
              </div>
            </div>
          </div>

          <div
            v-if="tab === 'hint'"
            class="d-flex fs-column w-100 no-events"
            style="gap: 0.5rem"
          >
            <div
              v-for="(item, idx) in [
                {
                  title: $t('range_builder.chart_yours'),
                  solution: rab_solution_picked,
                  freKey: 'strategy',
                },
                {
                  title: $t('range_builder.chart_correct'),
                  solution: solution_picked,
                  freKey: 'total_frequency',
                },
              ]"
              :key="idx"
              class="f-column flex-1"
            >
              <div
                class="text-small weight_500 tab_rounded tab_rounded_straight-left mr-auto"
                style="
                  --height: 1.5rem;
                  --clr-back: var(--clr-black-1-3);
                  padding: 0.25rem 0.75rem 0 0.75rem;
                "
              >
                {{ item.title }}
              </div>
              <HorizontalChart
                style="--clr-box-back: var(--clr-black-1-3); padding: 0.5rem"
                class="gw_box flex-1"
                :legendRaiseFirst="true"
                :limitLegendTo="9"
                :skeleton="false"
                :grouping="grouping"
                :showBetsIn="showBetsIn"
                :hasLegend="true"
                :freKey="item.freKey"
                :solution="item.solution"
                :useHex="useHex"
              />
            </div>
          </div>

          <div
            v-if="tab === 'poker_table'"
            class="d-flex flex-1 gw_table-box-layout"
            style="gap: 1rem; padding: 0.25rem"
          >
            <PokerTableStudy
              :spot="hSpot"
              :namespace="''"
              :gameformat="gameformat"
              class="flex-1 gw_table-box-layout_pokertable"
              style="
                min-width: 22rem;
                font-size: 0.75rem;
                min-height: 14rem;
                --margin-horizontal: 0;
                --cards-space: 0;
                padding: 2rem;
                --clr-table-back: var(--clr-black-0-3);
              "
            />
            <StudyPlayersTable
              style="min-width: 14rem"
              class="gw_table-box-layout_playersinfo"
              :asBlocks="true"
              :players="[hero, opponent]"
              :bettingInfo
            />
          </div>
        </div>
      </template>
    </TabBox>

    <!-- <div
      class="f-column w-100 gw_box"
      style="min-width: 0; padding: 0.5rem"
    > -->
    <TabBox
      v-else
      class="raibudrrasd_tabbox"
      :options="[
        { id: 'frequency', tour: { tour: 'ndsetfrequency' } },
        { id: 'painter', tour: { tour: 'ndsetstrategy' } },
        { id: 'locker', tour: { tour: 'ndsetlock' } },
      ]"
      :tab="btnMode"
      idKey="id"
      style="--tbbox-overflow-y: unset; --tbbox-overflow-x: unset"
      :hasScrollRight="false"
      @click="
        item => {
          $emit('click:btnmode', item.id)
          $emit('click:paintmode', item.id === 'locker' ? 'paint_lock' : 'paint_custom')
        }
      "
    >
      <template #tab="{ item }">
        <div
          class="mdi mr-1"
          :class="
            {
              painter: 'mdi-brush',
              frequency: 'mdi-sine-wave',
              locker: 'mdi-lock-outline',
            }[item.id]
          "
        ></div>
        {{ $t(`common.${item.id}`) }}
      </template>
      <RangeBuilderActions
        v-if="btnMode === 'painter'"
        :style="`opacity: ${onStart ? 0 : 1}`"
        style="min-height: 11rem; min-width: 0; gap: 0.25rem"
        :solution="rab_solution_paint"
        :showBetsIn="showBetsIn"
        :useHex="useHex"
        :grouping="grouping"
        v-bind="$attrs"
      >
      </RangeBuilderActions>
      <div
        v-if="btnMode === 'frequency'"
        class="flex-1 f-column"
        style="gap: 0.25rem"
      >
        <RangeBuilderActionsSliders
          style="min-height: 11rem; min-width: 0"
          :solution="rab_solution_picked"
          :showBetsIn="showBetsIn"
          :useHex="useHex"
          :grouping="grouping"
          :nodelockFreqMode="nodelockFreqMode"
          :lockedActions="lockedActions"
          @update:actionssliders="
            ({ actions, keepLocks }) => {
              if (nodelockFreqMode === 'keep_locked_hands' && lockedHands.all_locked) return
              $emit('update:actionssliders', { actions, keepLocks })
            }
          "
          @update:nodelockfreqmode="item => $emit('update:nodelockfreqmode', item)"
          @update:lockedactions="item => $emit('update:lockedactions', item)"
        >
          <MessageOverlaySkeleton
            v-if="nodelockFreqMode === 'keep_locked_hands' && lockedHands.all_locked"
            class="gw_mesblock_container anim-fade-in"
            :isBlurred="true"
            :isTopDown="true"
            style="--content-margin: auto auto auto auto; --radius: 6px"
          >
            <div class="clr-white text-medium weight_500 gw_box">
              {{ $t('messages.all_hands_locked') }}

              <div
                class="gw_btn gw_btn_primary gw_btn_uppercase mt-2"
                @click="$emit('click:unlockall')"
              >
                <div class="mdi mdi-lock-open-outline mr-2"></div>
                {{ $t('nodelock.remove_locks_from_all') }}
              </div>
            </div>
          </MessageOverlaySkeleton>
        </RangeBuilderActionsSliders>
      </div>
      <div
        v-if="btnMode === 'locker'"
        class="f-column flex-1"
        style="min-height: 11rem"
      >
        <div
          class="d-flex flex-1"
          style="gap: 0.5rem"
        >
          <div
            v-for="(item, idx) in [
              {
                icon: 'mdi-lock',
                sub: $t('nodelock.add_locks_to_all'),
                fn: () => $emit('click:lockall'),
                hide: lockedHands.all_locked,
              },
              {
                icon: 'mdi-lock-open-outline',
                sub: $t('nodelock.remove_locks_from_all'),
                fn: () => $emit('click:unlockall'),
                hide: !lockedHands.length,
              },
            ]"
            :key="idx"
            v-ripple="true"
            class="gw_btn-square gw_btn_outlines text-normal clr-hover clr-grey weight_500 flex-1"
            style="gap: 0.5rem; padding: 1rem"
            :class="{
              'no-events opacity_4': item.hide,
            }"
            @click="item.fn()"
          >
            <IconAndText
              :icon="item.icon"
              style="
                --icon-size: 3.875rem;
                --icon-color: currentColor;
                --icon-sub-clr: currentColor;
              "
              :subtitle="item.sub"
            />
          </div>
        </div>
      </div>
    </TabBox>

    <TabBox
      class="raibudrrasd_tabbox flex-1"
      :swKey="mobile ? 'sw_rangebuilder_handmatrix_all' : 'sw_rangebuilder_handmatrix'"
      :hasScrollRight="false"
      :hasNamedTabSlot="true"
    >
      <template #tab_filters="{ value }">
        <div
          class="f-center std_noevents"
          style="gap: 0.5rem"
        >
          {{ $t('tabs.filters') }}
          <UnSwitcherNew
            :class="{ 'opacity_5 no-events': value !== 'filters' }"
            swKey="sw_study_filter_intersection"
            tstPrefix="studyfilter"
            style="--uns-opener-clr: inherit"
            @click="() => $store.dispatch(SNK('sol_filters_handle_mode_change', namespace))"
          />
        </div>
      </template>
      <template #default="{ tab }">
        <div
          class="flex-1 f-column std_cont"
          tour="categories"
        >
          <div
            v-if="tab === 'strategy'"
            class="d-flex flex-1"
          >
            <slot name="strategy"></slot>
          </div>
          <StudyCombos
            v-if="tab === 'hands'"
            style="--zoom-duration: 1.2s"
            :combosMaximizible="false"
            :highlightIsoBucket="builderMode === 'mode_nodelock'"
            :hasZoom="false"
            player="0"
            :group="heroGroup"
            :viewProps="viewProps"
            :filterCombos="filterCombos"
            :filterEvCompare="filterEvCompare"
            :evProps="evProps"
            :mobile="mobile"
            :grouping="grouping"
            :showBetsIn="showBetsIn"
            :rangeKey="viewProps.rangeKey"
            showProp="strategy"
            :asEmpty="false"
            :useHex="useHex"
            :hasPremiumGameformat="hasPremiumGameformat"
            :gameformat="gameformat"
            :rangeTab="rangeTab"
            :hasBlockers="false"
            @click="val => $emit('hand:click', val)"
            @touchstart="e => $emit('hands:mousedown', e)"
            @touchmove="e => $emit('hands:touchmove', e)"
            @mouseenter="val => $emit('hand:mouseenter', val)"
            @mousedown="val => $emit('hand:mousedown', val)"
          />

          <StudyFilters
            v-if="tab === 'filters'"
            :namespace="namespace"
            :canAISolve="false"
            :catDraws="catDraws"
            :catHands="catHands"
            :catEqBuckets="catEqBuckets"
            :catEqBucketsAdvanced="catEqBucketsAdvanced"
            :applyFilterActionName="applyFilterActionName"
            :useHex="useHex"
            :mobile="mobile"
            :showFlopContent="showFlopContent"
            :isPreflop="isPreflop"
            style="padding: 0.5rem"
            :filterCategories="filterCategories"
            mode="builder"
            :hasArrowBtn="false"
            :hasFilterBtn="true"
            v-bind="$attrs"
            @touchstart="e => $emit('hands:mousedown', e)"
            @mousedown="e => $emit('hands:mousedown', e)"
          >
            <template #filter_pills>
              <StudyFiltersPills
                v-if="!mobile"
                :namespace="namespace"
                class="no-shrink ml-auto flex-1 mb-auto"
                style="
                  --clr-pills-back: var(--clr-black-1);
                  max-width: 100%;
                  --active-margin-bottom: var(--ff-gap);
                "
                :alwaysVisible="false"
                :street="street"
                soltab="strategy"
                :filterCombos="filterCombos"
                :showBetsIn="showBetsIn"
              />
            </template>
          </StudyFilters>
          <CombosTableHero
            v-if="tab === 'summary'"
            :hasBlockers="false"
            :heroGroup="heroGroup"
            :showGroupCombos="!!heroGroupId"
            :tableGroups="rab_tableGroups"
            :useHex="useHex"
            :street="street"
            :mobile="mobile"
            :showFlopContent="showFlopContent"
            :showBetsIn="showBetsIn"
            :bettingInfo
            :grouping="grouping"
            :tableMouseover="tableMouseover"
            :hasPremiumGameformat="hasPremiumGameformat"
            :solElite="solElite"
            :gameformat="gameformat"
            @mousedown="e => $emit('hands:mousedown', e)"
            @combo:mousedown="h => handleComboMousedown(h)"
            @combo:mouseenter="h => handleComboMouseenter(h)"
          />
        </div>
      </template>
    </TabBox>

    <div
      class="confirm-box d-flex my-auto"
      style="gap: 0.25rem; transtion: 0.44s; max-width: 100%"
      :style="onStart ? 'opacity: 0.25;pointer-events:none' : ''"
    >
      <slot name="before_confirm"></slot>
      <div
        class="d-flex flex-1 gw_box mw_0"
        style="--box-padding: var(--confirm-box-padding); gap: 0.25rem"
      >
        <LinkGuide
          v-if="!mobile && builderMode === 'mode_nodelock'"
          class="mr-auto my-auto ml-1"
          :link="links_url_links.nodelocking_how_it_works.url"
          :text="links_url_links.nodelocking_how_it_works.text"
          @click.stop
        />
        <div
          class="text-medium clr-grey ml-auto my-auto truncate"
          v-html="
            builderMode === 'mode_nodelock'
              ? $t('messages.click_here_to_nodelock_strategy')
              : $t('messages.click_hero_to_evaluate_strategy')
          "
        ></div>
        <div
          v-if="builderMode === 'mode_nodelock'"
          tour="ndrbconfirm"
          class="gw_btn gw_btn_primary text-normal weight_500 ml-autos ml-2"
          style="--height: 1.875rem"
          @click="
            () => {
              if (!lockedHands.length) {
                $store.dispatch('router_set_dialogs', 'prompt-nodelock-dialog')
              } else {
                $emit('click:confirm')
              }
            }
          "
        >
          <LoaderSpinner
            v-if="loadingConfirm"
            style="--size: 1.5rem; position: absolute"
          />
          <span :class="{ opacity_0: loadingConfirm }">
            {{ $t('btn.nodelock') }}
          </span>
        </div>

        <div
          v-else-if="!canConfirm"
          tour="rbconfirm"
          class="gw_btn gw_btn_primary text-normal weight_500 ml-autos ml-2"
          style="--height: 1.875rem"
          @click=";(canConfirm = !canConfirm), (canClear = false)"
        >
          {{ $t('btn.see_results') }}
        </div>
        <div
          v-if="canConfirm"
          class="gw_btn text-normal weight_500 ml-autos ml-2"
          style="--height: 1.875rem"
          @click="canConfirm = !canConfirm"
        >
          {{ $t('btn.cancel') }}
        </div>
        <div
          v-if="canConfirm"
          class="gw_btn gw_btn_primary text-normal weight_500"
          style="--height: 1.875rem"
          @click="$emit('click:confirm')"
        >
          {{ $t('btn.confirm') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TabBox from '@/components/lib/TabBox'
import StudyFiltersPills from '@/components/Study/StudyFiltersPills'
import HorizontalChart from '@/components/Charts/HorizontalChart/HorizontalChart'
import PokerTableStudy from '@/components/PokerTable/PokerTableStudy'
import StudyPlayersTable from '@/components/DataTables/v2/tables/StudyPlayersTable/StudyPlayersTable'
import GwBtns from '@/components/lib/GwBtns'
import CombosTableHero from '@/components/DataTables/v2/tables/CombosTable/CombosTableHero'
import IconAndText from '@/components/Poker/Overlays/IconAndText'
import LoaderSpinner from '@/components/Loaders/LoaderSpinner'
import MessageOverlaySkeleton from '@/components/Poker/Overlays/MessageOverlaySkeleton'
import LinkGuide from '@/components/AppBar/LinkGuide'
import UnSwitcherNew from '@/components/Switchers/UnSwitcher_new'
import { SNK } from '@/helpers/helpers'

import RangeBuilderActions from '@/components/Practice/RangeBuilder/RangeBuilderActions'
import RangeBuilderActionsSliders from '@/components/Practice/RangeBuilder/RangeBuilderActionsSliders'
import StudyCombos from '@/components/Study/StudyCombos'
import StudyFilters from '@/components/Study/StudyFilters'
import float_mix from '@/mixins/float_mix'
import links_mix from '@/mixins/links_mix'
import format_mix from '@/mixins/format_mix'

export default {
  name: 'RangeBuilderAside',
  components: {
    RangeBuilderActions,
    RangeBuilderActionsSliders,
    StudyCombos,
    StudyFilters,
    TabBox,
    StudyFiltersPills,
    HorizontalChart,
    PokerTableStudy,
    StudyPlayersTable,
    GwBtns,
    CombosTableHero,
    IconAndText,
    LoaderSpinner,
    MessageOverlaySkeleton,
    LinkGuide,
    UnSwitcherNew,
  },
  mixins: [float_mix, links_mix, format_mix],
  props: {
    namespace: { required: true, type: String },
    toolTabs: { default: () => ['tools', 'hint', 'poker_table'] },
    // toolBtns: { default: () => ['paint', 'lock'] },
    // hasConfirm: { type: Boolean,  default: true },
    showFlopContent: Boolean,
    isPreflop: Boolean,
    applyFilterActionName: { default: () => 'sol_data_applyFilter' },
    builderMode: String,
    btnMode: String,
    paintMode: String,
    loadingConfirm: Boolean,
    lockedActions: Array,
    catDraws: Array,
    catHands: Array,
    catEqBuckets: Array,
    catEqBucketsAdvanced: Array,
    rab_tableGroups: Array,
    solElite: Object,
    lockMode: String,
    nodelockFreqMode: String,
    onStart: Boolean,
    rangeTableGroupsIds: { default: () => [] },
    rab_solution_paint: { default: () => [] },
    solution_picked: { default: () => [] },
    rab_solution_picked: { default: () => [] },
    combos: { default: () => [] },
    useHex: Boolean,
    street: String,
    hero: Object,
    opponent: Object,
    mobile: Boolean,
    grouping: String,
    showBetsIn: String,
    bettingInfo: Object,
    smallLayout: Boolean,
    hasMinify: Boolean,
    landScapeLayout: Boolean,
    hasTableTile: { type: Boolean, default: true },
    rangeTab: String,
    actionHighlighted: Object,
    hSpot: Object,
    heroGroupId: String,
    opponentGroupId: String,
    heroGroup: Object,
    opponentGroup: Object,
    heroHandsIds: { default: () => [] },
    opponentHandsIds: { default: () => [] },
    filteredHeroHandsIds: { default: () => [] },
    filteredOpponentHandsIds: { default: () => [] },
    viewProps: Object,
    filterCombos: Object,
    filterEvCompare: Object,
    filterCategories: Array,
    evProps: Object,
    tableMouseover: Boolean,
    hasPremiumGameformat: Boolean,
    gameformat: Object,
    loadingStrategy: Boolean,
  },
  emits: [
    'click:btnmode',
    'click:paintmode',
    'lock:reset',
    'update:actionssliders',
    'update:nodelockfreqmode',
    'update:lockedactions',
    'click:unlockall',
    'click:lockall',
    'hand:click',
    'hands:mousedown',
    'hands:touchmove',
    'hand:mouseenter',
    'hand:mousedown',
    'click:confirm',
    'combo:mousedown',
    'combo:mouseenter',
  ],
  data() {
    return {
      canConfirm: false,
    }
  },
  methods: {
    handleComboMousedown(h) {
      this.$emit('combo:mousedown', h)
    },
    handleComboMouseenter(h) {
      this.$emit('combo:mouseenter', h)
      this.$store.dispatch(SNK('sol_detail_hover_hand', this.namespace), {
        hand: h,
        tableGroups: this.rab_tableGroups,
      })
    },
  },
  computed: {
    lockedHands() {
      if (this.loadingStrategy) {
        return {
          locked_hands_ids: [],
          all_locked: false,
          length: 0,
        }
      }

      let allLocked = true
      let res = (this.rab_tableGroups || []).reduce((a, gg) => {
        const r = gg.combos.reduce((aa, hh) => {
          if (hh.players[0].default.range && !hh.is_locked) allLocked = false
          return hh.is_locked ? [...aa, hh.id] : aa
        }, [])
        return [...a, r]
      }, [])
      res = res.flat()
      return {
        locked_hands_ids: res, //
        all_locked: allLocked,
        length: res.length,
      }
    },
    tabRange() {
      return this.tab === 'range'
    },
  },
}
</script>
<style lang="scss" scoped>
.raibudrrasd {
  --gap: var(--laytsttd-gap, 0.5rem);
  gap: var(--gap);

  flex-direction: column;
  display: flex;
  flex: 1;

  min-height: 0;
  min-width: 0;

  &_tabbox {
    --tbbox-content-gap: var(--laytsttd-gap) !important;
    --tbbox-content-padding: var(--laytsttd-padding-content) !important;
  }

  --small-layout-aside-max-height: 33vh;
  --confirm-box-padding: 0.5rem;
}

@media (max-width: 1023px) {
  .raibudrrasd {
    --confirm-box-padding: 0.25rem;
  }
}

@media screen and (orientation: landscape) {
  .raibudrrasd {
    --small-layout-aside-max-height: auto;
  }
}
</style>
